import firebase from "firebase/compat/app";
import "firebase/compat/messaging";
import { getAnalytics } from "firebase/analytics";
import axios from "axios";

// ✅ Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyAqfmWEw2dZ565hyAubkGV9rVUKTJEN630",
  authDomain: "RHB-ba6d7.firebaseapp.com",
  projectId: "RHB-ba6d7",
  storageBucket: "RHB-ba6d7.firebasestorage.app",
  messagingSenderId: "815844031758",
  appId: "1:815844031758:web:da6176fa9e25c361472b5f",
  measurementId: "G-Q3C102QX1P",
};

const VAPID_KEY = "";

// ✅ Initialize Firebase app
const app = firebase.initializeApp(firebaseConfig);
getAnalytics(app);

const messaging = firebase.messaging();

/**
 * ✅ Register existing service worker (from CRA) and link it to Firebase Messaging
 */
export const registerFirebaseServiceWorker = async () => {
  try {
    const registration = await navigator.serviceWorker.ready; // ✅ Use CRA's existing service worker
    // console.log("✅ Firebase Messaging using existing Service Worker:", registration);

    messaging.useServiceWorker(registration);

    // Continue with token
    await requestForToken();
  } catch (err) {
    // console.error("❌ Firebase SW setup failed:", err);
  }
};

/**
 * ✅ Request push token and send to backend
 */
export const requestForToken = async () => {
  try {
    // console.log("🟡 Requesting notification permission...");
    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      // console.warn("❌ Notification permission denied.");
      return;
    }

    // console.log("🔑 Requesting Firebase Token...");
    const token = await messaging.getToken({ vapidKey: VAPID_KEY });

    if (token) {
      // console.log("✅ Token received:", token);

      const accessToken = localStorage.getItem("accessToken");
      if (!accessToken) {
        // console.error("❌ Access token missing.");
        return;
      }

      // console.log("📡 Sending token to backend...");
      const response = await axios.post(
        `https://renukahydraulic.imrtechsolutions.com/api/notifications/save-token/`,
        {
          token,
          platform: "web",
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      // console.log("✅ Token saved:", response.data);
    } else {
      // console.warn("❌ Token was null or empty.");
    }
  } catch (err) {
    // console.error("❌ Error in requestForToken:", err);
  }
};

/**
 * ✅ Listen for foreground notifications
 */
export const onMessageListener = () =>
  new Promise((resolve) => {
    messaging.onMessage((payload) => {
      resolve(payload);
    });
  });

export { messaging };
